import styles from './Footer.module.scss';
import { Text } from '../../../../shared/ui/Text/Text';
import { mapPin } from '../../../../shared/assets/svg/mapPin';
import { Link } from 'react-router-dom';
import { Stack } from '../../../../shared/ui/Stack/Stack';
import Maps from '../../../../feature/Map/Maps';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import { telegramIcon } from '../../../../shared/assets/svg/telegramIcon';
import { callIcon } from '../../../../shared/assets/svg/callIcon';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

const Footer = () => {

    useGSAP(() => {
        gsap.fromTo(".footer__title", {"--opacity": 0,  "--x1": "-50px",  "--x2": "50px" }, 
                                        {"--opacity": 1, "--x1": "0px",  "--x2": "0px",  
                                            duration: 3, 
                                            scrollTrigger: {
                                                trigger: ".footer__title"
        }});
        gsap.fromTo(".footer__phone", {opacity: 0, }, {opacity: 1,
            duration: 3, 
            delay:1,
            scrollTrigger: {
            trigger: ".footer__phone"
        }});
        gsap.fromTo(".footer__wapp", {opacity: 0, }, {opacity: 1,
            duration: 3, 
            delay:2,
            scrollTrigger: {
            trigger: ".footer__wapp"
        }});
        gsap.fromTo(".line", {opacity: 0, }, {opacity: 1,
            duration: 3, 
            delay:3,
            scrollTrigger: {
            trigger: ".line"
        }});
    }, [])

    return ( 
        <footer  className={styles.footer}>            
            <div  className={styles.container}>
                <Stack                         
                    justifyContent = 'justifyCenter' 
                    alignItems = 'alignCenter'                         
                >
                    <Text size='xl' className={`footer__title ${styles.title}`}>
                        запишитесь на консультацию <br/>удобным для вас способом
                    </Text>                           
                </Stack>
                <Stack                         
                    justifyContent = 'justifyCenter' 
                    alignItems = 'alignCenter' 
                    className={styles.icons}                        
                >
                    <Link to='tel:+79288408020' className={`footer__phone ${styles.phone}`}>
                        {callIcon()} 
                    </Link>
                    <Link to="https://t.me/+79288408020" target='_blank' className={`footer__wapp ${styles.phone}`}>
                        {telegramIcon()}                     
                    </Link>                 
                </Stack>
                <div className={styles.footer__card}>        
                    <Stack 
                        direction = 'column'
                        gap = '8'
                        justifyContent = 'justifyCenter'
                        alignItems = 'alignCenter'
                        className={styles.footer__address}>
                        <div className={styles.mapIcon}>
                            {mapPin()}
                        </div>
                        <Text size='m'className={styles.footer__data}>
                            350072, Российская Федерация, <br/>Краснодарский край, <br/>город Краснодар, <br/>улица им. Сергея Есенина, <br/>дом №133
                        </Text>
                    </Stack>
                    <div> <hr className={`line ${styles.verticalLine}`}/></div>
               <Maps/>
                </div>
            </div>
        </footer>
    );
}
 
export default Footer;